import { create } from 'zustand'
import { api } from '@/lib/api'

interface AuthState {
  isAuthenticated: boolean
  isLoading: boolean
  user: { username: string; role: string } | null
  login: (username: string, password: string) => Promise<void>
  logout: () => Promise<void>
  checkAuth: () => void
}

export const useAuth = create<AuthState>((set) => ({
  isAuthenticated: false,
  isLoading: true,
  user: null,

  login: async (username: string, password: string) => {
    const data = await api.login(username, password)
    set({
      isAuthenticated: true,
      user: { username: data.user.username, role: data.user.role },
    })
  },

  logout: async () => {
    await api.logout()
    set({ isAuthenticated: false, user: null })
  },

  checkAuth: () => {
    const hasToken = api.hasToken()
    set({
      isAuthenticated: hasToken,
      isLoading: false,
    })
  },
}))

// Check auth on app load
if (typeof window !== 'undefined') {
  useAuth.getState().checkAuth()
}
